"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'PopupPanel',
    methods: {
        onclick() {
            this.$emit('close');
        },
        keylistener(event) {
            if (event.key === 'Escape') {
                this.onclick();
                return;
            }
        },
    },
    computed: {},
    unmounted() {
        window.removeEventListener('keydown', this.keylistener);
    },
    mounted() {
        window.addEventListener('keydown', this.keylistener);
    },
});
